import template from './estate-body.pug';

export const EstateBodyComponent = {
  template,
  bindings: {
    filter: '<',
    records: '<',
    checkedIds: '<',
    view: '<',
    onCheck: '&',
    gridOptions: '<?',
    loading: '<?',
    onFilterChange: '&',
    isModal: '<?',
    isMobile: '<?',
  },
  controller: class EstateBodyComponent {
    constructor($state) {
      'ngInject';
      this.view = 'table';
      this.$state = $state;
    }

    $onChanges({ records } = {}) {
      if (records && records.currentValue) {
        console.log('records', records);
      }
    }

    $onInit() {
    }

    applyFilter({ filter, searchId }) {
      this.onFilterChange({
        $event: { filter, searchId }
      });
    }

    checkIds({ checkedIds }) {
      this.onCheck({
        $event: { checkedIds }
      });
    }

    handleMarkerClick({ estate }) {
      this.$state.go('main.estates.show', { id: estate.id });
    }
  }
};
